import { CheckBox } from 'devextreme-react'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { getBrand } from '../../../../services/getBrand'
import useFormatMessage from '../../../../utils/useFormatMessage'
const MarkaRoleYonetimi = ({ employeeDetail }) => {

    const [brand, setBrand] = useState([])
    const { t } = useFormatMessage();

    useEffect(() => {
        (async () => {
            const data = await getBrand();
            setBrand(data);
        })();

    }, [])



    return (

        <Row style={{ height: '250px' }}>
            <Col sm="12">
                <Row style={{ display: "flex", justifyContent: "center" }}>
                    <Col xl="11" className='mb-3' style={{ width: "750px", opacity: "0.6", backgroundColor: "#1DB2F5", borderRadius: "15px", padding: "5px", marginTop: "10px" }}>
                        <div style={{ fontSize: "15px", color: 'white', textAlign: "center", verticalAlign: "center" }}>{t("Marka Adları")}</div>
                    </Col>
                </Row>
                <Row>

                    {brand && brand.map((item) => (
                        <Col
                            className='brandCol'
                            id={`brandCol-${item.id}`}
                            sm='4'
                            md='3'
                            style={{ marginBottom: '10px' }}
                            key={item.id} >
                            <CheckBox
                                defaultValue={employeeDetail?.brand_ids?.includes(item.id) || false}
                                text={item.brand_name}
                            />

                        </Col>

                    ))}
                </Row>
            </Col>
        </Row>
    )
}
export default MarkaRoleYonetimi;
